module.exports = __webpack_public_path__ + "static/media/Piercing-eyebrow.f916d75a.png";